import { IS_CLIENT } from '@repo/common-utils';

interface Data {
  bizName: string;
  refundAmount: string;
  refundId: string;
  refundStatus: string;
  refundStage?: string;
  cancelStage?: string;
  bank?: string;
  accountNo?: string;
  accountOwner?: string;
  tin?: string;
  snmcSpcTxreAmt?: number;
  cenSnmcTxreAmt?: number;
  empIncrEtrpTxamtDdcAmt?: number;
  intgEmpTxamtDdcAmt?: number;
  sctyInfeeTxamtDdcAmt?: number;
  reSearchRequestId?: number | null;
  tritxRefundInfo?:
    | {
        bizName: string;
        refundAmount: string;
        refundId: string;
        refundStatus: string;
        refundStage?: string;
        cancelStage?: string;
        bank?: string;
        accountNo?: string;
        accountOwner?: string;
        tin?: string;
        tritxReSearchRequestId?: number | null;
        businessInfo: {
          taxpayerName: string;
        };
      }
    | null
    | undefined;
}

export type IndisSearchRefundData = Data | undefined;

const indisSearchRefundDataKey = 'indis-search-refund-data';

export function initIndisSearchRefundData() {
  if (IS_CLIENT) {
    sessionStorage.removeItem(indisSearchRefundDataKey);
  }
}

export function getIndisSearchRefundData(): IndisSearchRefundData {
  if (IS_CLIENT) {
    const item = sessionStorage.getItem(indisSearchRefundDataKey);
    if (item) {
      return JSON.parse(item) as Data;
    }
  }

  return undefined;
}

export function setIndisSearchRefundData(data: IndisSearchRefundData) {
  if (IS_CLIENT) {
    sessionStorage.setItem(indisSearchRefundDataKey, JSON.stringify(data || null));
  }
}
